<template>
  <div
    id="home"
    :style="{
      display: showSiderbar ? 'flex' : 'block',
    }"
  >
    <Sidebar v-if="showSiderbar" />
    <router-view />
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import { getUserInfo, companyBrandConfigList } from "@/assets/js/request";
import { mapState, mapMutations } from "vuex";
import dayjs from "dayjs";
export default {
  components: {
    Sidebar,
  },
  computed: {
    showSiderbar() {
      let temp = ["/login", "/accountType"];
      return !temp.includes(this.$route.path);
    },
  },
  methods: {
    ...mapMutations(["SET_USERINFO", "SET_PARAMSID", "SET_ACTIVECOMPANYINFO"]),
    toGetUserInfo() {
      getUserInfo().then((res) => {
        if (res.code == 200) {
          res.data.loginUser = this.convertNullToEmpty(res.data.loginUser);
          //测试使用
          // res.data.companyInfo.status = "0";

          this.SET_USERINFO(res.data);
          let paramsId = {
            companyId: "", // 企业/工作室 id 用户传空
            userId: "", // 个人的传，企业公司传空
          };
          let activeCompanyInfo = {};
          if (res.data.loginUser.permission == "STUDIO") {
            //这个if不能提到上面  后台没有提供默认信息 未上传的时候整个对象为空
            if (res.data.studioInfo?.id) {
              paramsId.companyId = res.data.studioInfo?.id;
              activeCompanyInfo = res.data.studioInfo;
              this.companyBrandConfigList(res.data.studioInfo?.id);
              this.$store.commit(
                "SET_HISTORY_LIST",
                res.data.studioHistoryList && res.data.studioHistoryList.length
                  ? res.data.studioHistoryList
                  : [
                      {
                        historyTime: dayjs().format("YYYY-MM-DD"),
                        history: null,
                      },
                    ]
              );
            }
          } else if (res.data.loginUser.permission == "COMPANY") {
            //这个if不能提到上面  后台没有提供默认信息 未上传的时候整个对象为空
            if (res.data.companyInfo?.id) {
              paramsId.companyId = res.data.companyInfo?.id;
              activeCompanyInfo = res.data.companyInfo;
              this.companyBrandConfigList(res.data.companyInfo?.id);
              this.$store.commit(
                "SET_HISTORY_LIST",
                res.data.companyHistoryList &&
                  res.data.companyHistoryList.length
                  ? res.data.companyHistoryList
                  : [
                      {
                        historyTime: dayjs().format("YYYY-MM"),
                        history: null,
                      },
                    ]
              );
            }
          } else {
            paramsId.userId = res.data.loginUser.id;
          }
          if (activeCompanyInfo?.status == "0") {
            this.$message({
              message: `当前账号信息审核未通过，请在个人中心重新上传审核信息`,
              type: "warning",
            });
          }
          this.SET_PARAMSID(paramsId);
          this.SET_ACTIVECOMPANYINFO(activeCompanyInfo);
        }
      });
    },
    convertNullToEmpty(obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null) {
          obj[key] = "";
        } else if (typeof obj[key] === "object" && obj[key] !== null) {
          convertNullToEmpty(obj[key]); // 递归处理嵌套对象
        }
      });
      return obj;
    },
    async companyBrandConfigList(companyId) {
      try {
        const res = await companyBrandConfigList({
          companyId,
        });
        if (res.code !== 200) {
          throw new Error(res.msg);
        }
        const item = res.data.find((child) => child.fileSource === "BRANDLOGO");
        if (item) {
          this.$store.commit("SET_BRAND_LOGO", {
            fileUrl: item.fileUrl,
          });
        }
      } catch (e) {}
    },
  },
  created() {
    
    const scriptEl = document.createElement("script");
    scriptEl.src =
      "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
    document.body.appendChild(scriptEl)
    let token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/login");
      return;
    }
    this.toGetUserInfo();
    this.$bus.$off("toGetUserInfo").$on("toGetUserInfo", (e) => {
      this.toGetUserInfo();
    });
  },
};
</script>

<style lang="scss">
@import "@/assets/css/common.scss";

#home {
  display: flex;
  background: #f9f9f9;
  height: 100%;
  min-height: 100vh;
  min-width: 1440px;
}
</style>
